export const limitForSelectedUnit = (limit, isCelsius) => {
  return isCelsius ? limit : (limit * 9) / 5 + 32;
};

export const temperatureIsMoreThan = (value, limit, isCelsius) => {
  return value > limitForSelectedUnit(limit, isCelsius);
};
